import { yup } from '@framework/validation';
import { ComputeExpressionSchema } from '../../../../expressions/compute/validation/ComputeExpressionSchema';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent';
import { IComputedNumberWidget } from '../IComputedWidget';

export const ComputedNumberConfigSchema = CommonInputWidgetConfigSchema.shape({
  type: yup.string().required().exact(WidgetType.ComputedNumber).label('Tipo'),
  expression: ComputeExpressionSchema.label('Espressione'),
  layout: BaseLayoutSchema.shape({
    hide: yup.boolean().required().default(false).label('Nascondi elemento'),
    removeBorder: yup
      .boolean()
      .required()
      .default(false)
      .label('Rimuovi bordo'),
  }),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IComputedNumberWidget>;
